import { RobotOutlined, WarningOutlined } from '@ant-design/icons'
import { Button } from 'aa_common/front-end/antd'
import { If } from 'aa_common/front-end/components'
import { Col, Collapse as AntCollapse, Image, Row, Typography } from 'antd'
import { getNs } from 'common/i18n-config'
import { PresenterSuggestAssetCategoryResponse } from 'common/open-api'

import { Card, CardContent, CardIcon, Collapse, RegisterInMaster, Warning } from '../styles'

const { Text, Title } = Typography
const { Panel } = AntCollapse

const { t, useNsReady } = getNs(['components/organisms/assets/asset-form'])

type AISubmittedResultProps = {
  data?: PresenterSuggestAssetCategoryResponse
  imageSrc?: string
  onTryAgain?: () => void
  onReflect?: () => void
}

export const AISubmittedResult = ({ data, imageSrc, onTryAgain, onReflect }: AISubmittedResultProps) => {
  useNsReady()
  return (
    <Card>
      <Row align="middle" justify="space-between" style={{ marginBottom: '24px' }}>
        <Col span={24}>
          <Row align="middle" gutter={12}>
            <Col>
              <CardIcon>
                <RobotOutlined style={{ fontSize: '16px', color: 'white' }} />
              </CardIcon>
            </Col>
            <Col>
              <div>
                <Title level={5}>{t('ai_analysis_result')}</Title>
                <Text type="secondary" style={{ fontSize: '14px' }}>
                  {t('ai_analysis_result_description')}
                </Text>
              </div>
            </Col>
          </Row>
        </Col>
      </Row>

      {/* Content Card */}
      <CardContent>
        <Row gutter={24} justify="space-between">
          {/* Image */}
          <If condition={imageSrc}>
            <Col span={6}>
              <Image width={96} height={96} src={imageSrc} />
            </Col>
          </If>

          {/* Details */}
          <Col span={17}>
            <Row gutter={[16, 16]}>
              <Col span={24}>
                <div>
                  <Text type="secondary">{t('name')}</Text>
                  <Title level={5} />
                </div>
              </Col>

              <Col span={24}>
                <div>
                  <Text type="secondary">{t('asset_name_by_katakana')}</Text>
                  <Title level={5}>{/* TODO: Add asset name by katakana */}</Title>
                </div>
              </Col>

              <Col span={12}>
                <div>
                  <Text type="secondary">{t('asset_category')}</Text>
                  <Title level={5} style={{ color: '#3b7de9' }}>
                    {data?.asset_category_name}
                  </Title>
                </div>
              </Col>

              <Col>
                <div>
                  <Text type="secondary">{t('service_life')}</Text>
                  <Title level={5} style={{ color: '#3b7de9' }}>
                    {data?.service_life}
                  </Title>
                </div>
              </Col>
            </Row>
          </Col>
        </Row>

        <If condition={data?.proposed_new_category}>
          <Warning>
            <Row gutter={16} justify="space-between" align="middle">
              <Col span={15}>
                <Row justify="space-between" align="middle">
                  <Col span={4}>
                    <WarningOutlined style={{ fontSize: '24px', color: '#fab300' }} />
                  </Col>
                  <Col span={20}>
                    <Text>{t('ai_warning_unregistered_asset_category')}</Text>
                  </Col>
                </Row>
              </Col>
              <Col span={9}>
                <RegisterInMaster to="/master/asset-categories/new">{t('register_in_master')}</RegisterInMaster>
              </Col>
            </Row>
          </Warning>
        </If>
      </CardContent>

      <Collapse collapsible="header">
        <Panel header={t('show_decision_rationale')} key="1">
          <Text>{data?.reasoning}</Text>
        </Panel>
      </Collapse>

      <Row gutter={16}>
        <Col span={12}>
          <Button block onClick={onReflect}>
            {t('reflect_to_form')}
          </Button>
        </Col>
        <Col span={12}>
          <Button color="grey" block onClick={onTryAgain}>
            {t('try_again')}
          </Button>
        </Col>
      </Row>
    </Card>
  )
}
